import React, { useEffect, useState } from 'react'
import MainLogo from '../images/imageAssets/Main-Logo.png'
import MiniLogo from '../images/imageAssets/Mini-Logo.png'

function NavigationBar() {

    
    
    const [MobileOpen, setMobileOpen] = useState(false);
    const [isMobile, setIsMobile] = useState(false)


    useEffect(()=>{
        if (window.innerWidth < 1000) {
            setIsMobile(true)
            console.log(isMobile);
            
        }
    },[])
    
    const toggleMenu = ()=>{
        setMobileOpen((prevMobileOpen)=>!prevMobileOpen)
    }

    const scrollAndMove = ()=>{
        if(isMobile){
            setMobileOpen((prevMobileOpen)=>!prevMobileOpen)
            
        }
    }
    

  return (
    
    <>
        <button onClick={toggleMenu} className="Mobile-Icon">
            <svg width="64px" height="64px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fillRule="evenodd" clipRule="evenodd" d="M12 4C11.4477 4 11 4.44772 11 5C11 5.55228 11.4477 6 12 6C12.5523 6 13 5.55228 13 5C13 4.44772 12.5523 4 12 4ZM15 5C15 6.65685 13.6569 8 12 8C10.3431 8 9 6.65685 9 5C9 3.34315 10.3431 2 12 2C13.6569 2 15 3.34315 15 5ZM12 11C11.4477 11 11 11.4477 11 12C11 12.5523 11.4477 13 12 13C12.5523 13 13 12.5523 13 12C13 11.4477 12.5523 11 12 11ZM15 12C15 13.6569 13.6569 15 12 15C10.3431 15 9 13.6569 9 12C9 10.3431 10.3431 9 12 9C13.6569 9 15 10.3431 15 12ZM11 19C11 18.4477 11.4477 18 12 18C12.5523 18 13 18.4477 13 19C13 19.5523 12.5523 20 12 20C11.4477 20 11 19.5523 11 19ZM12 22C13.6569 22 15 20.6569 15 19C15 17.3431 13.6569 16 12 16C10.3431 16 9 17.3431 9 19C9 20.6569 10.3431 22 12 22Z" fill="#000000"/>
            </svg>
        </button>
        <div data-ismobileopen={MobileOpen} className="Main-Navigation--wrapper">
            <nav className="Main-Navigation">
                <div className="Mobile-home-button--wrapper">
                    <a onClick={scrollAndMove} href="#HeroSection" className="Home-button-image">
                        <img src={MainLogo} alt="Center line Cabinets logo" className="Company-logo-full" />
                    </a>
                </div>
                <ul className="Main-Navigation-list">
                    <li className="Main-Navigation-list-item isMobileVis">
                        <a href="#HeroSection" className="Home-button-mini-logo">
                            <img src={MiniLogo} alt="Center line Cabinets logo" className="mini-logo" />
                        </a>
                    </li>
                    <li className="Main-Navigation-list-item">
                        <a onClick={scrollAndMove} href="#AboutSection" className="button button--Navigation">about</a>
                    </li>
                    <li className="Main-Navigation-list-item">
                        <a onClick={scrollAndMove} href="#GallerySection" className="button button--Navigation">gallery</a>
                    </li>
                </ul>
            </nav>
        </div>
    </>
  )
}

export default NavigationBar